// extracted by mini-css-extract-plugin
module.exports = {"EditorIndicators":"_2iVl3_gikoVNsziaeigYIE","FixedIndicatorsContainer":"_1rRKPA8HpC-lxoxvjdsbP","ProgressBar":"_2RTiWlh1BO8nEarovGJHIc"};